import { RootState } from '../index';

export const selectCurrentUser = (state: RootState): any => state.user.currentUser;
export const selectCurrentUserLoading = (state: RootState): any => state.user.currentUserLoading;
